import { FinancialAccountRrifType } from '@/modules/financialaccount/constants/FinancialAccountRrifType';
import { FinancialAccountMeta } from '@/modules/financialaccount/models/meta/FinancialAccountMeta';

export class FinancialAccountRrifMeta extends FinancialAccountMeta {
  constructor(model: Partial<FinancialAccountRrifMeta> = {}) {
    super(model);

    this.type = model.type ?? FinancialAccountRrifType.NONE.key;
  }
}
